<template>
  <div class="wrapper">
    <side-bar title="mobileQuest">
      <mobile-menu slot="content"></mobile-menu>

      <template v-for="section in sections">
        <sidebar-link
          v-if="section.link"
          :to="section.link"
          :key="section.link"
        >
          <i :class="section.icon"></i>
          <p>{{ section.name }}</p>
        </sidebar-link>
        <!-- <div class="card bg-transparent p-3" v-else> -->
        <div v-else class="card bg-transparent p-3" :key="section.name">
          <!-- Los grupos con `desplegable` arrancan cerrados y se abren al tocarlos.
               Los que no lo declaran siguen mostrando sus links siempre, como antes. -->
          <div
            v-if="section.desplegable"
            class="grupo-head"
            @click="alternarGrupo(section.name)"
          >
            <i v-if="section.icon" :class="section.icon" class="grupo-icono"></i>
            <span>{{ section.name }}</span>
            <i
              class="fas fa-chevron-down grupo-chevron"
              :class="{ abierto: gruposAbiertos[section.name] }"
            ></i>
          </div>
          <template v-else>{{ section.name }}</template>
          <template v-if="!section.desplegable || gruposAbiertos[section.name]">
            <sidebar-link
              v-for="section in section.sections"
              :key="`${section.name}-${section.link}`"
              :to="section.link"
            >
              <div class="d-flex align-items-center">
                <i style="font-size: 16px" :class="section.icon"></i>
                <p>{{ section.name }}</p>
              </div>
            </sidebar-link>
          </template>
        </div>
      </template>
      <!--      <template slot="bottom-links">-->
      <!--        <sidebar-link class="active"-->
      <!--                      to="/admin/upgrade">-->
      <!--          <i class="nc-icon nc-alien-33"></i>-->
      <!--          <p>Upgrade to PRO</p>-->
      <!--        </sidebar-link>-->
      <!--      </template>-->
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>

      <dashboard-content @click="toggleSidebar"> </dashboard-content>

      <!--      <content-footer></content-footer>-->
    </div>
  </div>
</template>
<style lang="scss">
.grupo-head {
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;

  .grupo-icono {
    font-size: 16px;
    margin-right: 8px;
  }

  .grupo-chevron {
    margin-left: auto;
    font-size: 11px;
    opacity: 0.6;
    transition: transform 0.15s ease;

    &.abierto {
      transform: rotate(180deg);
    }
  }
}
</style>
<script>
import TopNavbar from "./TopNavbar.vue";
import axios from "axios";
import DashboardContent from "./Content.vue";
import MobileMenu from "./MobileMenu.vue";

export default {
  components: {
    TopNavbar,
    DashboardContent,
    MobileMenu,
  },
  data: () => ({
    sections: [],
    gruposAbiertos: {},
  }),
  async created() {
    // Armar el menú con los permisos ya conocidos; si /users/me falla,
    // la navegación no queda vacía (un 401 redirige al login vía interceptor).
    this.buildSections();

    try {
      const response = await axios.get("/users/me");
      const usuario = response.data.user;
      const permisos = response.data.permissions;

      localStorage.setItem("usuario", JSON.stringify(usuario));
      localStorage.setItem("permisos", JSON.stringify(permisos));

      this.buildSections();
    } catch (e) {
      console.error(e);
    }
  },
  methods: {
    alternarGrupo(nombre) {
      this.$set(this.gruposAbiertos, nombre, !this.gruposAbiertos[nombre]);
    },
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    buildSections() {
      const baseItems = [
        {
          name: "Roles",
          link: "/admin/roles",
          icon: "fas fa-user-check",
        },
      ];

      try {
        const permisos = JSON.parse(localStorage.getItem("permisos"));

        if (permisos.includes("SEC.ModificarParametrosLocales")) {
          baseItems.push({
            name: "Parametros Locales",
            link: "/admin/parametros-locales",
            icon: "fas fa-shield-alt",
          });
        }
      } catch (e) {
        console.error(e);
      }

      this.sections = [
        ...baseItems,
        {
          name: "ABM Usuarios",
          link: "/admin/users",
          icon: "fas fa-users",
        },
        {
          name: "ABM AVL's",
          link: "/admin/avl",
          icon: "fas fa-car-battery",
        },
        {
          name: "ABM de Chips",
          link: "/admin/chips",
          icon: "fas fa-sim-card",
        },
        {
          name: "Clientes y Contratos",
          link: "/admin/clientes",
          icon: "fas fa-smile",
        },
        {
          name: "Acceso para testeos",
          link: "/admin/acceso-testeos",
          icon: "fas fa-clipboard-list",
        },
        {
          name: "Tratamiento de cobranzas",
          sections: [
            {
              name: "Evitar suspensiones",
              link: "/admin/suspensiones/evitar",
              icon: "fas fa-exclamation-triangle",
            },
            {
              name: "Tratamiento de suspensiones",
              link: "/admin/suspensiones/tratamiento",
              icon: "fas fa-exclamation-circle",
            },
          ],
        },
        {
          name: "Módulos de Pagos",
          link: "/admin/pagos",
          icon: "fas fa-money-bill-alt",
        },
        {
          name: "Estado de Cuentas",
          link: "/admin/cuentas",
          icon: "fas fa-file-invoice-dollar",
        },
        {
          name: "Caja",
          link: "/admin/caja",
          icon: "fas fa-coins",
        },
        {
          name: "Tools",
          icon: "fas fa-toolbox",
          desplegable: true,
          sections: [
            {
              name: "Informe Cobertura GSM",
              link: "/admin/tools/cobertura-gsm",
              icon: "fas fa-signal",
            },
          ],
        },
      ];
    },
  },
};
</script>
